import { Tooltip } from 'antd';
import React from 'react';
type FieldItemProp = {
  iconName: string;
  label: string;
  tips?: string;
};
const FieldItem = (props: FieldItemProp) => {
  return (
    <span className='field-item'>
      <i className={props.iconName}></i>
      {props.tips ? (
        <Tooltip title={props.tips}>
          <span>{props.label}</span>
        </Tooltip>
      ) : (
        <span>{props.label}</span>
      )}
    </span>
  );
};

export default React.memo(FieldItem);
